module.exports = __webpack_public_path__ + "img/melissa-programadas.ba5d70d4.png";